import { apiClient } from './client';
import { normalizeUser } from './normalizeUser';
import type { AuthResponse, LoginRequest, RegisterRequest } from './types';

interface RawAuthResponse {
  accessToken: string;
  user: Parameters<typeof normalizeUser>[0];
}

function normalizeAuthResponse(raw: RawAuthResponse): AuthResponse {
  return {
    accessToken: raw.accessToken,
    user: normalizeUser(raw.user),
  };
}

export const authApi = {
  login: (payload: LoginRequest) =>
    apiClient.post('/auth/login', payload).then((r) => normalizeAuthResponse(r.data)),

  register: (payload: RegisterRequest) =>
    apiClient.post('/auth/register', payload).then((r) => normalizeAuthResponse(r.data)),

  /**
   * POST /auth/change-password - ChangePasswordRequest(CurrentPassword, NewPassword). Every other
   * session is ended server-side, so the response carries a fresh token pair for THIS session.
   */
  changePassword: (payload: { currentPassword: string; newPassword: string }) =>
    apiClient.post('/auth/change-password', payload).then((r) => normalizeAuthResponse(r.data)),

  /** POST /auth/forgot-password - always 204; the API never says whether the address has an account. */
  forgotPassword: (email: string) => apiClient.post('/auth/forgot-password', { email }).then(() => undefined),

  /** POST /auth/reset-password - the token comes from the emailed link. Does not sign in. */
  resetPassword: (payload: { token: string; newPassword: string }) =>
    apiClient.post('/auth/reset-password', payload).then(() => undefined),

  /** The refresh cookie identifies the session; the server revokes it and clears the cookie. */
  logout: () => apiClient.post('/auth/logout').then((r) => r.data),
};
